exports.APIS = {
  Auth: "/common/auth/admin-login",

  Dashboard: "/admin/dashboard/dashboard-data",
  Wallet: {
    history: "/admin/wallet/history",
    WithdrawReq: "/admin/wallet",
    FundReq: "/admin/wallet/fund-request",
    WithdrawCommissionReq: "/admin/wallet/request-commission",
  },

  FunTarget: {
    bets: "/admin/fun-target/bets",
    result: "/admin/fun-target/result",
    winner: "/admin/fun-target/winner",
    control: "/admin/results",
  },

  Roulette: {
    bets: "/admin/roulette/bets",
    manualResult: "/admin/roulette/manual-result",
  },
  Support: {
    Support: "/admin/support",
    Reminder: "/admin/support/reminder",
    Deposit: "/admin/support/deposite-query",
    Withdraw: "/admin/support/withdraw-query",
    IFSC: "/admin/support/ifsc-query",
    ChangePassword: "/common/auth/change-password",
    ChangeBankName: "/admin/support/change-bank-name-query",
    ModifyBankInfo: "/admin/support/modify-bank-information-query",
    ModifyUpi: "/admin/support/modify-upi-query",
    AddUSDTAddress: "/admin/support/add-usdt-address-query",
    ChangeUSDTAddress: "/admin/support/update-usdt-address-query",
    ActivityBonus: "/admin/support/activity-bonus-query",
  },
  Masters: {
    Turnover: "/admin/masters/turnover",
    Game_Rule: "/admin/masters/game-rule",
    Announcement: "/admin/masters/announcement",
    Game_Offer: "/admin/masters/game-offer",
    storeBanner: "/admin/setting/store-banner",
    Concent_And_Term: "/admin/masters/concent-and-terms",
    User_Feedback: "/admin/masters/user-feedback",
    Frame: "/admin/masters/frame",
    Frame_Category: "/admin/masters/frame-category",
    Return_Reason: "/admin/masters/return-reason",
    Cancel_Reason: "/admin/masters/cancel-reason",
    Room_Cancel_Reason: "/admin/masters/room-cancel-reason",
    meditaionGuideline: "/admin/masters/meditation-guidelines",
    meditaionEssence: "/admin/masters/meditation-essence",
    meditaionBenefit: "/admin/masters/meditation-benefit",
    Level: "/admin/masters/level",
    our_mission: "/admin/masters/our-mission",
    our_vission: "/admin/masters/our-vission",
    at_om_tapovan: "/admin/masters/at-om-tapovan",
    blogCategory: "/admin/masters/blog-category",
    welcomeText: "/admin/masters/welcome-text",
    gurudevContents: "/admin/masters/gurudev-contents",
    Festival: "/admin/masters/festival",
    Volunteer_position: "/admin/masters/volunteer-position",
    Days_of_service: "/admin/masters/day-of-service",
    Hours_of_service: "/admin/masters/hour-of-service",
    Gender: "/admin/masters/gender",
    homeBanner: "/admin/masters/banners",
    Country: "/admin/masters/country",
    spiritualInsights: "/admin/masters/spiritual-insight",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Area: "/admin/masters/area",
    Faq: "/admin/masters/faqs",
    Blog: "/admin/masters/blog",
    Pravachan: "/admin/masters/pravachan",
    SubFaq: "/admin/masters/subfaq",
    SocialMedia: "/admin/masters/socialmedia",
    Coupons: "/admin/coupon",
    Privacy_and_Policy: "/admin/masters/privacy_policy",
    Return_Policy: "/admin/masters/returnpolicy",
    Terms_and_Conditions: "/admin/masters/terms_and_conditions",
    Career: "/admin/masters/careers",

    insightExclusive: "/admin/insights/exclusive",
    insightVideo: "/admin/insights/insight-video",
    insightAudio: "/admin/insights/insight-audio",
    insightArticle: "/admin/insights/insight-article",
    spandan: "/admin/spandan",
    qoute_of_the_day: "/admin/qoute_of_the_day",

    guruji_wisdom: "/admin/guruji_wisdom",
    our_core_vision: "/admin/our_core_vision",
    spandanSession: "/admin/spandan/spandan-session",
    spandanBanner: "/admin/spandan/spandan-banner",
    spandanVideo: "/admin/spandan/spandan-video",

    donation: "/admin/explore/donation",
    volunteering: "/admin/explore/volunteering",

    todaysPath: "/admin/masters/meditation",
    gurudevShorts: "/admin/masters/gurudev-shorts",
    spiritualTruth: "/admin/masters/spiritual-truth",
    seva: "/admin/masters/seva",
    ourOfferings: "/admin/masters/our-offerings",
    testimonial: "/admin/masters/testimonial",
    Language: "/admin/masters/language",
    // todaysPath: "/admin/masters/blog",

    Chant: "/admin/masters/chant",
    ChantType: "/admin/masters/chant-type",

    Event_category: "/admin/masters/event-category",

    Event_type: "/admin/masters/event-type",

    Event: "/admin/masters/event",
    EventReg: "/admin/masters/event/all-event-registration",

    Event_program: "/admin/masters/event-program",

    Unit: "/admin/masters/unit",
    roomType: "/admin/masters/room-type",

    ContactUsCentres: "/admin/contact-us-centres",

    Shipping_Delivery_Policy: "/admin/masters/shipping_delivery_policies",

    Donation_Cancellation_Refund_Policy:
      "/admin/masters/donation_cancellation_refund_policies",

    About_us: "/admin/masters/about-us",
    Social_link: "/admin/masters/social-link",
    App_Setup: "/admin/masters/app-setup",
    AgentPaneltext: "/admin/masters/agent-panel-text",
  },

  Room_Manage: {
    facilities: "/admin/room-management/facility",
    Room: "/admin/room-management/room",
    roomBooking: "/common/masters/all-bookings",
  },

  // common
  Commons: {
    AllFrameCategory: "/common/masters/all-frame-category",
    AllEvents: "/common/masters/all-events",
    AllLevels: "/common/masters/all-level",
    AllEventCategory: "/common/masters/all-event-category",
    AllEventType: "/common/masters/all-event-types",
    eventRegistrations: "/common/masters/all-event-registration",
    AllDeliveryBois: "/common/masters/all-delivery-boys",
    AllCountry: "/common/masters/all-country",
    AllFacility: "/common/masters/all-facility",
    AllRoomTypes: "/common/masters/all-room-type",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllArea: "/common/masters/all-area",
    AllCategory: "/common/masters/all-p-category",
    AllSubCategory: "/common/masters/all-subcategory",
    AllChildCategory: "/common/masters/all-childcategory",
    AllPartners: "/common/masters/all-partners",
    AllWhyChooseUs: "/common/masters/all-whychooseus",
    AllIndustry: "/common/masters/all-industry",
    AllDepartment: "/common/masters/all-department",
    AllCompanySize: "/common/masters/all-companysize",
    AllNeeds: "/common/masters/all-needs",
    AllFaq: "/common/masters/all-faqs",
    AllSubFaq: "/common/masters/all-subfaq",

    AllMeterial: "/common/masters/all-material",
    AllLamination: "/common/masters/all-lamination",
    AllEnvelope: "/common/masters/all-envelope",
    AllPrintLocation: "/common/masters/all-print-location",
    AllQuantity: "/common/masters/all-quantity",
    AllOrientation: "/common/masters/all-Orientation",
    AllShapes: "/common/masters/all-shapes",

    AllSocialMedia: "/common/masters/all-socialmedia",
    AllBlog: "/common/masters/all-blogs",
    AllBlog_Category: "/common/masters/all-blogcategory",
    AllSize: "/common/masters/all-size",
    AllDownloadType: "/common/masters/all-download-type",
    AllOrderStatus: "/common/masters/all-order-status",
    AllPermmission: "/common/masters/all-permission",
    AllOrderStatusCount: "/common/masters/all-count-order-status",

    AllRoles: "/common/masters/all-roles",

    AllTeam: "/common/masters/all-team",
    AllUser: "/common/masters/users",
    AllProduct: "/common/masters/all-product",

    AllPropertyType: "/common/masters/all-property-type",
    AllPropertyStatus: "/common/masters/all-property-status",
    AllProperty: "/common/masters/all-property",
    AllRoom: "/common/masters/all-rooms",

    BuySubscription: "/common/buy-subscription",
    AllSubscriptionHistory: "/common/masters/all-subscription-history",
    paymentHistory: "/admin/wallet",
    Language: "/common/masters/all-language",

    AllUnits: "/common/masters/all-unit",
    AllCenter: "/common/masters/center",
    AllDonations: "/common/masters/donations",
  },

  //product Manage
  ProductManage: {
    Category: "/admin/masters/p-category",
    SubCategory: "/admin/productmanage/subcategory",
    ChildCategory: "/admin/productmanage/childcategory",
    Needs: "/admin/productmanage/needs",
    Product: "/admin/products",
    OfferProduct: "/admin/productmanage/offered-product",
  },

  OrderManage: {
    Order: "/admin/orders/product-order",
    OrderStatus: "/admin/orders/product-order/update-status",
    ReturnOrderStatus: "/admin/orders/return-order/update-status",
    OrderCancle: "/admin/orders/cancel-order",
    OrderRefund: "/admin/orders/refund-order",
    acceptRefundStatus: "/admin/orders/accept-refund-order",
    OrderReplace: "/admin/orders/replace-order",
    OrderReturn: "/admin/orders/return-order",
    AssignDeliveryBoy: "/admin/orders/product-order/assign-boy",

    PaymentProof: "/admin/order-management/accountant-payment-proof",
    PrintingCount: "/admin/order-management/printing-count",
    QCComment: "/admin/order-management/qc-comment",
    AssignDesigner: "/admin/order-management/assign-designer",

    DesignerNote: "/admin/order-management/designer-notes",
    DesignerNote: "/admin/order-management/designer-notes",
  },

  AboutUs: {
    Welcome: "/admin/aboutus/welcomes",
    What_We_Are: "/admin/aboutus/what_we_ares",
    What_Media_Do: "/admin/aboutus/what_media_dos",
  },

  Customers: {
    Contact_Us: "/admin/contact-us",
    User: "/admin/customer",
  },
  Games: {
    Color_Prediction: "/admin/color-prediction",
    Toss_Karo: "/admin/toss-karo",
    User: "/admin/customer",
  },
  Volunteers: {
    volunteer: "/admin/volunteer-details",
  },

  Donations: {
    donation: "/admin/donation/donation-details",
    donationbyid: "/admin/donation/donation-details-by-id",
  },

  ReviewRating: {
    ReviewRating: "/admin/products/rating",
  },

  UserManagement: {
    Roles: "/admin/roles",
    Owner: "/admin/customer-management/customer",
  },

  PropertyManage: {
    Property: "/admin/property-management",
    PropertyStatus: "/admin/property-management/property-status",
    room: "/admin/property-management/room",
    tenant: "/admin/tenant-management",
  },
  Donation: {
    Donation_Card: "/admin/donation",
    // GetDonations:"/common/masters/donations"
  },

  Management: {
    SSM: "/admin/management/ssm",
    SM: "/admin/management/sm",
    Master: "/admin/management/master",
    Client: "/admin/management/client",
    Deposit: "/admin/management/statement/deposit",
    Withdrawal: "/admin/management/statement/withdrawal",
  },
};
